import React from 'react';
import './Button.scss';
import PropTypes from 'prop-types';

interface ButtonProps {
    width?: string;
    children?: React.ReactNode;
    onClick: () => void;
    background?: string;
    className?: string;
    disabled?: boolean;
    id?: string;
}

const Button: React.FC<ButtonProps> = ({
                                           width = "fit-content",
                                           children,
                                           onClick,
                                           background = "transparent",
                                           className = "",
                                           disabled = false,
                                           id
                                       }) => {
    return (
        <button
            className={`Button ${className}`}
            id={id}
            disabled={disabled}
            onClick={onClick}
            style={{ width, background }}
        >
            {children}
        </button>
    );
};

Button.propTypes = {
    width: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    background: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
};

export default Button;
